// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Row, Col } from "@components";
import { formatDateTime } from "@transformers/date";
import { formatAuthoredBy } from "@transformers/names";
import "./organization-summary.style.scss";

type OwnProps = $Exact<{
  summary: Object,
  branch: Object | null,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export const OrganizationSummary = (props: Props) => (
  <Row className="organization-summary">
    <Col>
      <hr />
      <span>{props.t("DEPARTMENT_REF")}</span>
      <p>{props.branch && props.branch.reference}</p>
    </Col>
    <Col>
      <hr />
      <span>{props.t("DATE_CREATED")}</span>
      <p>{props.branch ? formatDateTime(props.branch.createdAt) : "-"}</p>
    </Col>
    <Col>
      <hr />
      <span>{props.t("CREATED_BY")}</span>
      <p>{props.branch ? formatAuthoredBy(props.branch.createdBy) : "-"}</p>
    </Col>
    <Col>
      <hr />
      <span>{props.t("CONTACTS_IN_DEPARTMENT")}</span>
      <p>{props.summary.directContacts}</p>
    </Col>
    <Col>
      <hr />
      <span>{props.t("INHERITED_CONTACTS")}</span>
      <p>{props.summary.inheritedContacts}</p>
    </Col>
  </Row>
);

export default localize()(OrganizationSummary);
